"use client";

import { cn } from "@frontend/shared/lib/utils";
import type { ReactNode } from "react";

export interface KioskFooterProps {
  children: ReactNode;
  className?: string;
  layout?: "single" | "split" | "stacked";
  align?: "left" | "center" | "right";
}

export const KioskFooter = ({
  children,
  className,
  layout = "single",
  align = "right",
}: KioskFooterProps) => {
  return (
    <div
      className={cn(
        "w-full flex gap-3",

        // Layout variants
        layout === "single" && "flex-row",
        layout === "split" && "flex-col sm:flex-row sm:justify-between",
        layout === "stacked" && "flex-col",

        // Alignment (for single layout)
        layout === "single" && align === "left" && "justify-start",
        layout === "single" && align === "center" && "justify-center",
        layout === "single" && align === "right" && "justify-end",

        className,
      )}
    >
      {children}
    </div>
  );
};

KioskFooter.displayName = "KioskFooter";
